import React, { Component } from 'react';
import { List, Avatar, message, Input, Button, Tag} from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const Search = Input.Search;

class Chats extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {title: '', body: ''};
    this.state = {redirect: false, chats: [], filteredChats: [], message: ''};
    this.validateToken = this.validateToken.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getChats = this.getChats.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getChats();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});

    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or gerente"))
      this.setState({redirect: true});
  }

  getChats() {
    let url = `${Configuration.apiServer}/api/v1/chats`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.setState({chats: resp.data, filteredChats: resp.data});
    });
  }

  handleMessage(event) {
    this.setState({message: event.target.value});
  }

  handleCreate() {
    axios.post(`${Configuration.apiServer}/api/v1/chats`, {chat: {body: this.state.message}}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.setState({message: ''});
      message.success('Mensaje creado');
      this.getChats();
    });
  }

  handleSearch(event) {
    const chats = this.state.chats.filter(chat => {
      return chat.body.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredChats: chats});
  }

  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Chat con caseta</h3>

            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%'}} />
          </div>

          <div className="d-flex justify-content-between align-items-center" style={{ background: '#f1f1f1', margin: '30px 0px', padding: '20px', borderRadius: '5px' }}>
            <Input placeholder="Nuevo mensaje" onChange={this.handleMessage} style={{ width: '90%' }} />
            <Button icon="plus" type="primary" shape="circle" onClick={this.handleCreate} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <List
              className="demo-loadmore-list"
              itemLayout="vertical"
              style={{ width: '100%' }}
              dataSource={this.state.filteredChats}
              renderItem={chat => (
                <List.Item>
                  <div className="d-flex align-items-center justify-content-between">
                    <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                    
                    <div style={{ width: '95%' }}>
                      <h6 className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                        <span>{chat.body}</span> 
                        <div>
                          <Tag color="cyan">{Configuration.formatDatetime(chat.created_at)}</Tag>
                        </div>
                      </h6>
                      <p style={{ marginBottom: '0px' }}>
                        <span>{chat.profile.names}</span>
                      </p>
                    </div>

                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
          
      </div>
    );
  }
}

export default Chats;



// WEBPACK FOOTER //
// ./src/pages/public/Chat.js